import { CAMPAIGNS_DASHBOARD_PAGE_ROUTE, DASHBOARD_PAGE_ROUTE } from 'utils/constants/app';

import { CampaignsTab } from 'store/models/campaignsDashboard';

export const getDashboardRoute = (isCampaignsDashboardRedesign: boolean): string =>
    isCampaignsDashboardRedesign ? `${CAMPAIGNS_DASHBOARD_PAGE_ROUTE}${CampaignsTab.Active}` : DASHBOARD_PAGE_ROUTE;
